import { UIEvent } from "react";

// За сколько px до конца списка подгружать следующую страницу.
const LOAD_MORE_THRESHOLD = 40;

// Подмножество результата RTK infiniteQuery, нужное списку.
interface InfiniteQueryResult<Page> {
  data?: { pages: Page[] };
  isLoading: boolean;
  isError: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => unknown;
}

export interface InfiniteListState<Item> {
  items: Item[];
  isLoading: boolean;
  isError: boolean;
  isFetchingNextPage: boolean;
  onScroll: (event: UIEvent<HTMLElement>) => void;
}

export const toInfiniteListState = <Page, Item>(
  result: InfiniteQueryResult<Page>,
  selectItems: (page: Page) => Item[],
): InfiniteListState<Item> => {
  const { data, isLoading, isError, isFetchingNextPage, hasNextPage } = result;

  const onScroll = ({ currentTarget }: UIEvent<HTMLElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = currentTarget;
    const isNearEnd =
      scrollHeight - scrollTop - clientHeight < LOAD_MORE_THRESHOLD;
    if (isNearEnd && hasNextPage && !isFetchingNextPage) {
      result.fetchNextPage();
    }
  };

  return {
    items: data?.pages.flatMap(selectItems) ?? [],
    isLoading,
    isError,
    isFetchingNextPage,
    onScroll,
  };
};
